import React, { useState } from 'react';

const Hero = ({ setSearchQuery }) => {
  const [searchInput, setSearchInput] = useState('');

  const handleSearch = () => {
    setSearchQuery(searchInput.toLowerCase());
  };

  const handleInputChange = (e) => {
    setSearchInput(e.target.value);
    setSearchQuery(e.target.value.toLowerCase());
  };

  return (
    <div className="hero h-50 bg-cover mb-10 border">
      <div className="container mx-auto flex flex-col justify-center items-center px-4 py-16 md:px-8">
        <h1 className="text-black text-4xl font-bold mb-4">Your Catchy Headline</h1>
        <p className="text-black text-lg mb-6">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vel lectus euismod, ultricies est et, semper nulla.</p>
        <div className="flex w-full sm:w-3/4 md:w-1/2">
          <input 
            type="text" 
            placeholder="Search..." 
            className="rounded-full px-3 py-2 p-4 text-gray-700 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full" 
            value={searchInput}
            onChange={handleInputChange}
          />
          <button 
            type="button" 
            className="rounded-full bg-blue-300 px-4 py-2 p-4 ml-2 text-black text-base  shadow-md hover:bg-blue-600 transition ease-in-out duration-150"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>


      </div>
      
    </div>
  );
};

export default Hero;
